import { CenteringDiv } from 'components/generic/HomePageComponents'
import Link from 'next/link'
import {
  HeroBannerContainer,
  HeroBannerTitle,
  HeroBannerText,
  CTAButton,
  HeroBannerButtonText,
  HeroBannerAligner,
} from './Styled'

const HeroBanner = ({ title, text, ctaButtonLink, ctaButtonText }) => (
  <HeroBannerContainer maxWidth={{ _: '100%', tablet: '750px', desktop: '100%' }}>
    <HeroBannerAligner>
      <CenteringDiv
        maxWidth={{ _: '100%', desktop: '60%' }}
        pb='2rem'
        pl='2rem'
        pt={{ _: '4rem', desktop: '1rem' }}
      >
        <HeroBannerTitle alignSelf='flex-start'>{title}</HeroBannerTitle>
        <HeroBannerText alignSelf='flex-start'>{text}</HeroBannerText>
        <Link href={ctaButtonLink} passHref={true}>
          <CTAButton fontSize='16px' height='24px' width='160px' mb='0px'>
            <HeroBannerButtonText>{ctaButtonText}</HeroBannerButtonText>
          </CTAButton>
        </Link>
      </CenteringDiv>
    </HeroBannerAligner>
  </HeroBannerContainer>
)
export default HeroBanner
